__webpack_require__.p = "https://c.daily.co/call-ui/2d6f6840515698a940b39bc3a84a14e91e54071e/_next/";